import { Response } from 'datx-jsonapi';
import { useResourcesInfinite } from 'datx-jsonapi-react';
import { useMemo } from 'react';
import { SWRInfiniteConfiguration } from 'swr/infinite';

import { queryLecturesByQueryInfinite } from '@/queries/thin-lectures';
import { ThinLecture } from '@/resources/ThinLecture';
import { extractSWRInfiniteData } from '@/utils/swr/extractSWRInfiniteData';

export function useLectureSearch(filters: Record<string, string> = {}, swrConfig?: SWRInfiniteConfiguration) {
  const sort = filters.query ? 'algolia_order' : 'held_at';

  const { data, error, size, ...swr } = useResourcesInfinite(
    queryLecturesByQueryInfinite({ filters, sort, pageSize: 16 }),
    swrConfig
  );

  const { items, meta, isLoadingMore, isReachingEnd, isEmpty } = useMemo(
    () => extractSWRInfiniteData<ThinLecture>(data as Array<Response<ThinLecture>>, error, size),
    [data, error, size]
  );

  return { data: items, meta, error, size, isReachingEnd, isLoadingMore, isEmpty, ...swr };
}
